import {Component, HostListener} from '@angular/core';
import {Notificacao} from "../../models/notificacao";
import {Token} from "../../../modules/auth/models/token";
import {AuthService} from "../../../modules/auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {NotificacaoService} from "../../services/notificacao.service";
import {Title} from "@angular/platform-browser";
import {ThemeService} from "../../services/theme.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: false
})
export class HeaderComponent {
  notificacoes: Notificacao[] = [];
  token: Token | undefined;
  showNotificacao = false;
  showInfoUsuarios = false;
  isDarkTheme = false;
  eAdmin = false;

  constructor(private tokenService: AuthService,
              private notificacaoService: NotificacaoService,
              private toastr: ToastrService,
              private titleService: Title,
              private themeService: ThemeService,
              private router: Router) {
    this.token = this.tokenService.AccessToken;
    this.eAdmin = this.token?.seguranca?.toUpperCase().includes('ADMIN') || false;

    this.themeService.isDarkTheme$().subscribe(isDark => {
      this.isDarkTheme = isDark;
    });

    this.carregarNotificacoes();
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  logoff() {
    Swal.fire({
      title: 'Deseja realmente sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#2E5266',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.tokenService.logoff();
        this.toastr.warning("Volte sempre!");
      }
    });
  }

  exibirNotificacoes(event?: Event) {
    event?.stopPropagation();
    this.showNotificacao = !this.showNotificacao;
  }

  @HostListener('document:click') fecharMenusAoClicarFora() {
    this.showNotificacao = false;
    this.showInfoUsuarios = false;
  }

  sairNotificacao() {
    this.showNotificacao = false;
  }

  verTodasNotificacoes(event: Event) {
    event.preventDefault();
    this.router.navigate(['/notificacoes']);
    this.showNotificacao = false;
  }

  private carregarNotificacoes() {
    this.notificacaoService.buscarPorUsuario().subscribe(resultado => {
      if (resultado.sucesso) {
        this.notificacoes = resultado.dados;
      }
    });
  }

  limparNotificacoes() {
    this.notificacaoService.limparNotificacoes().subscribe(resultado => {
      if (resultado.sucesso) {
        this.toastr.success("Notifiacações limpas com sucesso!");
        this.carregarNotificacoes();
        this.notificacoes = [];
        this.showNotificacao = false;
      }
    });
  }

  exibirInfoUsuario(event: Event) {
    event.stopPropagation();
    this.showInfoUsuarios = !this.showInfoUsuarios;
    this.showNotificacao = false;
  }

  sairInfoUsuario() {
    this.showInfoUsuarios = false;
  }

  navegarParaConta(secao: 'planos' | 'usuarios' | 'ajuda' | 'senha') {
    this.showInfoUsuarios = false;
    this.router.navigate(['/gestao/conta'], {queryParams: {secao}});
  }

}
